export {Tooltip} from './src';
export {TooltipAvatar} from './src/tooltip-avatar';
export {TooltipTextPrimary} from './src/tooltip-text-primary';
export {TooltipTextSecondary} from './src/tooltip-text-secondary';
